import { useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { IconCheckCircleFilled, IconFileClock } from '@iwoca/icons';
import { Button } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { VerifyNewBankAccountModal } from '../../../modals/addPaymentMethodModal/linkBankAccount/verifyNewBankAccountModal/VerifyNewBankAccountModal';
import StepItem from '../stepItem/StepItem';

const StepAction = ({
    status,
    setModalOpen
}: {
    status: string;
    setModalOpen: (modalOpen: boolean) => void;
}) => {
    if (status === 'COMPLETED') {
        return (
            <div>
                <IconCheckCircleFilled
                    data-testid="completed-action-icon"
                    height="24"
                    width="24"
                    fill="rgba(0, 77, 51, 1)"
                    xlinkTitle="checked"
                />
            </div>
        );
    }

    if (status === 'PENDING') {
        return (
            <Button
                variant="primary"
                disabled
                className="min-w-[124px]"
                data-testid="upload-bank-evidence-button"
            >
                <IconFileClock />
            </Button>
        );
    }

    return (
        <Button
            onClick={() => {
                tracking.ampli.fundingStepCtaClicked({
                    funding_step: 'Upload Bank Evidence'
                });
                setModalOpen(true);
            }}
            variant="primary"
            data-testid="upload-bank-evidence-button"
        >
            <FormattedMessage
                id="_.funding_requirements.upload_bank_evidence_button"
                defaultMessage="Verify"
            />
        </Button>
    );
};

export const UploadBankEvidenceAction = ({
    status,
    triggerRefetchFundingRequirements
}: {
    status: string;
    triggerRefetchFundingRequirements: () => void;
}) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const handleModalClose = () => {
        setIsModalOpen(false);
        triggerRefetchFundingRequirements();
    };

    return (
        <>
            <StepItem
                title={
                    <FormattedMessage
                        id="_.funding_requirements.upload_bank_evidence_title"
                        defaultMessage="Verify your bank account"
                    />
                }
                caption={
                    status === 'PENDING' ? (
                        <FormattedMessage
                            id="_.funding_requirements.upload_bank_evidence_caption_pending"
                            defaultMessage="Pending"
                        />
                    ) : (
                        <FormattedMessage
                            id="_.funding_requirements.upload_bank_evidence_caption"
                            defaultMessage="We need to verify your bank account. You can link via Open Banking or upload a recent bank statement."
                        />
                    )
                }
                action={
                    <StepAction status={status} setModalOpen={setIsModalOpen} />
                }
            />
            <VerifyNewBankAccountModal
                isModalOpen={isModalOpen}
                onClose={handleModalClose}
            />
        </>
    );
};
